<!-- @veltra/icons generated sha256:ceda10f261067b07 gen:8 source:src/svg/normal/help.svg -->
<script setup lang="ts">
defineOptions({ name: 'Help' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M14.994 8a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-1 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0M5.62 5.933a2.43 2.43 0 0 1 2.374-1.927 2.427 2.427 0 0 1 2.425 2.425c0 1.068-.82 1.902-1.647 2.239a.45.45 0 0 0-.278.422v.413a.497.497 0 0 1-.496.495.5.5 0 0 1-.504-.495v-.413c0-.608.368-1.129.898-1.347l.002-.001c.58-.236 1.025-.775 1.025-1.313 0-.785-.64-1.425-1.425-1.425-.612 0-1.135.388-1.336.93-.096.26-.317.495-.585.495-.276 0-.51-.227-.453-.498M7.394 11.6a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0"
    />
  </svg>
</template>
